module.exports = __webpack_public_path__ + "img/int4_rui_lag_01.b03754d1.jpg";